module.exports = __webpack_public_path__ + "img/76.6.CODm.1ae238d1.png";